import styled from 'styled-components';

export const OnboardingBlock = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  min-height: 100dvh;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  text-align: center;
  padding: 20px;

  .brand_logo {
    display: flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
    margin: 0 auto 28px;
    text-decoration: none;

    @media (min-width: 992px) {
      position: absolute;
      left: 24px;
      top: 24px;
      margin: 0;
    }

    .brand-mark {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 10px;
      background: var(--primary);
      color: var(--white);
      font-family: var(--base-font-serif);
      font-size: 18px;
      font-weight: 700;
      line-height: 1;
    }

    .brand-name {
      color: var(--text-color);
      font-family: var(--base-font-serif);
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.02em;
      line-height: 1;
    }
  }
`;

export const FormCol = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  .form-content {
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
  }
`;
